import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("eventos_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data.user);
        setOrg(data.org);
      })
      .catch(() => localStorage.removeItem("eventos_token"))
      .finally(() => setLoading(false));
  }, []);

  const persist = (data) => {
    localStorage.setItem("eventos_token", data.token);
    setUser(data.user);
    setOrg(data.org);
  };
  const persistSession = persist;

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.two_factor_required) return data;
    persist(data);
    return data;
  };

  const verify2fa = async (challenge, code) => {
    const { data } = await api.post("/auth/2fa/verify", { challenge, code });
    persist(data);
    return data;
  };

  const updateUser = (u) => setUser(u);

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    persist(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("eventos_token");
    setUser(null);
    setOrg(null);
  };

  const refreshOrg = (o) => setOrg(o);

  return (
    <AuthContext.Provider value={{ user, org, loading, login, verify2fa, updateUser, register, logout, refreshOrg, persistSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
